import pixMath from './pixMath.utils';
import stringUtils from './string.utils';
import languageConst from '@/consts/language.const.js';

const oneOutOfPrefix = (value, shouldTransform = true) => {
  return shouldTransform && value !== null && !Number.isNaN(value) ? `1:${value}` : value;
};

const pixTrunc = (computedExpression, shouldTransform = true) => {
  return shouldTransform ? Math.trunc(pixMath.evaluate(computedExpression)) : computedExpression;
};

const pixMin = (computedExpression, shouldTransform = true) => {
  const valueList = computedExpression.split(',');
  const isOnlyNumbers = valueList.every((minValues) => !isNaN(Number(minValues)));
  const notOnlyNumbers = !isOnlyNumbers ? valueList.filter((minValues) => !isNaN(Number(minValues))) : null;
  return shouldTransform && isOnlyNumbers ? Math.min(...valueList) : notOnlyNumbers;
};

const transformMonthsToYearsMonths = (value, shouldTransform = true) => {
  let labelYearsMonths = '';
  if (value === null || value === '' || value === 'null') {
    return '';
  }
  if (value !== 'null') {
    labelYearsMonths = shouldTransform ? _getLabelYearsMonths(value) : value;
  }
  return labelYearsMonths;
};

const transformYearsToYearsMonths = (value, shouldTransform = true) => {
  let labelYearsMonths = '';
  if (value === null || value === '' || value === 'null') {
    return '';
  }
  if (value !== 'null') {
    labelYearsMonths = shouldTransform ? _getLabelYearsMonths(value) : Number(value) / 12;
  }
  return labelYearsMonths;
};

const _getLabelYearsMonths = (value) => {
  const roundedMonths = Math.round(Number(value));
  if(Number.isNaN(roundedMonths)) return '';
  const nOfYears = Math.trunc(roundedMonths / 12);
  const nOfMonths = roundedMonths % 12;
  return `${nOfYears.toLocaleString(languageConst.EN)} years ${nOfMonths.toLocaleString(languageConst.EN)} months`;
};

/**
 * Generates a random value for a blurred field
 */
const getRandomFieldValue = () => {
  const randomValue = Math.random();

  if (randomValue < 0.4) {
    return '';
  }

  return stringUtils.getRandomString((Math.floor(randomValue * 10) + 1) * 2);
};

export default {
  oneOutOfPrefix,
  pixTrunc,
  transformMonthsToYearsMonths,
  transformYearsToYearsMonths,
  pixMin,
  getRandomFieldValue,
};
